import {ComponentType, createElement} from 'react';

import {DashboardTileProps, DashboardTileRenderer} from '../types/DashboardTileRenderer';
import {DashboardTileSize} from '../types/DashboardTileSize';

// Never close over anything that is not in `props` — DashboardTileContent memoises on those alone.
export function createDashboardTileRenderer<P extends DashboardTileProps>(
  Component: ComponentType<P & {size: DashboardTileSize}>,
  props: P
): DashboardTileRenderer {
  return {
    props,
    render: (size: DashboardTileSize) => createElement(Component, {...props, size}),
  };
}
